import React, { useState } from 'react';
import HeadedCard from '../../../Elements/HeadedCard';
import LabeledValues from '../../../Elements/LabeledValues';

function HeadedCardDemoComponent() {
  const [clicks, setClicks] = useState(0);

  return (
    <div style={{ maxWidth: 460 }}>
      <HeadedCard
        kicker='The only invoice'
        title='Monthly invoice'
        actions={[{ label: 'Edit', iconName: 'fa-solid fa-pen', onClick: () => setClicks(clicks + 1) }]}
        foot={<span>Edit clicked {clicks} times</span>}
      >
        <LabeledValues
          values={[
            { label: 'Invoice name', value: 'October 2026 Mystery Shops', isWide: true },
            { label: 'Purchase order #', value: null },
            { label: 'Currency', value: 'United States Dollars' },
          ]}
        />
      </HeadedCard>
    </div>
  );
}

export const headedCardDemo = {
  id: 'headed-card',
  title: 'Headed card',
  category: 'Cards',
  importPath: 'Elements/HeadedCard',
  notes: [
    'A card with a navy head: a small kicker over an Oswald title, and buttons on the right; then the body, and an optional grey foot.',
    'actions are { label, iconName, disabled, onClick }, drawn as light buttons that read on navy.',
    'First used for the invoice of the automatic invoicing setup; its body here is LabeledValues.',
  ],
  snippet:
    '<HeadedCard\n  kicker="The only invoice"\n  title="Monthly invoice"\n  actions={[{ label: "Edit", onClick: openEditor }]}\n  foot={<span>Copied from 4001302</span>}\n>\n  …\n</HeadedCard>',
  render: HeadedCardDemoComponent,
};
